var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-simple-table", { attrs: { dense: "" } }, [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("Acct Code")]),
            _c("th", [_vm._v("Reason")]),
            _c("th", { staticClass: "text-right" }, [_vm._v("Amount")]),
            _c("th", [_vm._v("Config")])
          ])
        ]),
        _c(
          "tbody",
          [
            _vm._l(_vm.voucherDetailList, function(item) {
              return _c("tr", { key: item.id }, [
                _c("td", [_vm._v(_vm._s(item.account_code.account_code))]),
                _c("td", [_vm._v(_vm._s(item.reason))]),
                _c("td", { staticClass: "text-right" }, [
                  _vm._v(_vm._s(item.amount.phpFormat()))
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "yellow darken-3",
                          text: "",
                          small: "",
                          dense: ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("update:edit", item)
                          }
                        }
                      },
                      [_c("v-icon", [_vm._v("mdi-pencil")])],
                      1
                    )
                  ],
                  1
                )
              ])
            }),
            _c("tr", [
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("Total")]),
              _c("td", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.voucherDetailList.sum("amount").phpFormat()))
              ]),
              _c("td", [_vm._v(" ")])
            ])
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }